<!-- 编辑销售报价单 -->
<template>
    <div class="business-content-main bj-edit" v-loading="searchApParams._visible" element-loading-spinner="none">
        <div>
            <div class="bread-nav">
                <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
            </div>
            <div class="section-title" @click="showMsg">
                <div>
                    <span>订单信息 {{ submitData.QCode ? '【' + submitData.QCode + '】' : '' }}</span>
                    <span v-show="!showOrderMsg && submitData.EntpCusName">&nbsp;&nbsp;&nbsp;&nbsp;客户：{{ submitData.EntpCusName }}</span>
                </div>
                <div>
                    <el-button size="small" class="search-btn btn-primary" @click="addCustomer(1)" v-if="!dataReadonly && submitData.CreatorType == 0"
                        >新增客户</el-button
                    >
                    <el-button size="small" class="search-btn btn-primary" @click="addCustomer(2)" v-if="!dataReadonly && submitData.EntpCusId">编辑客户</el-button>
                </div>
            </div>
            <div class="open-icon" @click="showMsg" v-show="!showOrderMsg">
                <img src="../../../assets/images/open-msg.png" />
            </div>
            <div class="quotation-order-infoes" v-show="showOrderMsg">
                <el-form ref="form" label-width="80px" style="width: 100%; padding-right: 10px; padding-left: 10px" :rules="rules">
                    <el-row :gutter="20">
                        <el-col :span="6"
                            ><div class="grid-content bg-purple">
                                <el-form-item label="选择客户" prop="EntpCusId">
                                    <el-select
                                        style="width: 100%"
                                        size="small"
                                        :disabled="dataReadonly"
                                        v-model="submitData.EntpCusId"
                                        filterable
                                        clearable
                                        remote
                                        @change="customerChange($event)"
                                        @visible-change="customerVisibleChange($event)"
                                        :remote-method="searchCustomer"
                                        v-select-scroll-more="searchCustomLoad"
                                        reserve-keyword
                                        placeholder="选择客户"
                                    >
                                        <el-option
                                            v-for="optionItem in customerList"
                                            :key="optionItem.EntpCusId"
                                            :data-msg="optionItem"
                                            :label="optionItem.EntpCusName"
                                            :value="optionItem.EntpCusId"
                                        ></el-option>
                                    </el-select>
                                </el-form-item></div
                        ></el-col>
                        <el-col :span="6"
                            ><div class="grid-content bg-purple">
                                <el-form-item label="出仓仓库" prop="WarehouseId" style="width: 100%">
                                    <el-input
                                        size="small"
                                        v-if="dataReadonly"
                                        :title="submitData.WarehouseName"
                                        v-model="submitData.WarehouseName"
                                        style="width: 100%"
                                        :disabled="true"
                                    ></el-input>
                                    <el-select
                                        v-else
                                        size="small"
                                        :disabled="dataReadonly"
                                        style="width: 100%"
                                        v-model="submitData.WarehouseId"
                                        placeholder="请选择"
                                        filterable
                                        clearable
                                        @visible-change="warehouseVisibleChange($event)"
                                        @change="warehouseChange"
                                    >
                                        <el-option v-for="item in warehouseList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId">
                                            <span style="float: left">{{ item.WarehouseName }}</span>
                                            <span v-if="item.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div></el-col
                        >
                        <el-col :span="6"
                            ><div class="grid-content bg-purple">
                                <el-form-item label="运费" prop="PriceSumShip">
                                    <el-input
                                        min="0"
                                        size="small"
                                        style="width: 100%"
                                        type="number"
                                        step="0.01"
                                        :disabled="dataReadonly"
                                        v-model.trim="submitData.PriceSumShip"
                                    ></el-input>
                                </el-form-item></div
                        ></el-col>
                        <el-col :span="6"
                            ><div class="grid-content bg-purple">
                                <el-form-item label="报价日期">
                                    <el-date-picker
                                        size="small"
                                        style="width: 100%"
                                        :disabled="dataReadonly"
                                        value-format="yyyy-MM-dd"
                                        v-model="submitData.QTime"
                                        type="date"
                                    ></el-date-picker>
                                </el-form-item></div
                        ></el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="6">
                            <div class="grid-content bg-purple">
                                <el-form-item label="期限日期">
                                    <el-date-picker
                                        size="small"
                                        style="width: 100%"
                                        :disabled="dataReadonly"
                                        value-format="yyyy-MM-dd"
                                        v-model="submitData.NeedTime"
                                        type="date"
                                    ></el-date-picker>
                                </el-form-item></div
                        ></el-col>
                        <el-col :span="6"
                            ><div class="grid-content bg-purple">
                                <el-form-item label="询价日期">
                                    <el-date-picker
                                        size="small"
                                        style="width: 100%"
                                        :disabled="dataReadonly"
                                        value-format="yyyy-MM-dd"
                                        v-model="submitData.ITime"
                                        type="date"
                                    ></el-date-picker>
                                </el-form-item></div
                        ></el-col>
                        <el-col :span="12"
                            ><div class="grid-content bg-purple">
                                <el-form-item label="客户要求" style="width: 100%">
                                    <el-input size="small" :disabled="dataReadonly" v-model.trim="submitData.Remark"></el-input>
                                </el-form-item></div
                        ></el-col>
                    </el-row>
                </el-form>
            </div>
            <div class="section-title" @click="hideMsg()">
                <div>商品明细</div>
                <div>
                    <el-button size="small" class="search-btn btn-primary" @click="showSearch()" v-if="!dataReadonly && submitData.CreatorType == 0"
                        >搜索配件(F2)</el-button
                    >
                </div>
            </div>
        </div>
        <!-- table body -->
        <div id="infinite-list" :style="{ height: infiniteListHeight + 'px' }" @click="hideMsg()">
            <ux-grid
                ref="infiniteTable"
                :data="dataList"
                keep-source
                :height="infiniteTableHeight"
                :checkboxConfig="{ highlight: false }"
                :edit-config="{ trigger: 'click', mode: 'row' }"
                :row-style="setRowStyle"
                highlight-current-row
                show-summary
                :summary-method="setSummaries"
            >
                <ux-table-column class-name="table-sort" type="index" title="序号" width="65"></ux-table-column>
                <ux-table-column field="APCode" title="汽配编码" edit-render resizable>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <div :class="['sales-apcode div-padding-12', { 'special-border': !row.APCode }]" @click="focusHandle('sapcode')">
                            <img class="info-icon" src="../../../assets/images/info.png" title="配件信息" @click.stop="showAPMsgDialog(row.EntpTempGoodsId)" />
                            <span>{{ row.APCode ? row.APCode : '请点击选中汽配编码' }}</span>
                            <el-tag v-if="row.State == 1" class="tag" type="warning">已删除</el-tag>
                            <el-tag v-if="row.IsTrans" class="tag" type="success">已转销售</el-tag>
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select
                            style="width: 100%"
                            ref="sapcode"
                            :allow-create="isCheckCode"
                            default-first-option
                            size="small"
                            v-model="scope.row.APCode"
                            value-key="APCode"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="汽配编码"
                            @focus="hideMsg"
                            @change="codeChange($event, scope.rowIndex)"
                            @visible-change="apCodeVisibleChange($event)"
                            :remote-method="searchCode"
                            v-select-scroll-more="searchCodeLoad"
                            @keyup.enter.native="keyEvent($event, 'APCode')"
                            @keyup.right.native="keyEvent($event, 'APCode')"
                            :disabled="dataReadonly || (scope.row.hasLock && lastRowIndex !== scope.rowIndex)"
                            popper-class="el-select-style-gray"
                            resizable
                        >
                            <el-option
                                v-for="optionItem in codeList"
                                :key="optionItem.EntpTempGoodsId"
                                :data-msg="optionItem"
                                :label="optionItem.APCode"
                                :value="isCheckCode ? optionItem.APCode : optionItem.EntpTempGoodsId"
                            >
                                <div class="option-content">
                                    <div class="project-Name">{{ optionItem.APCode }}</div>
                                    <div class="project-Name">{{ optionItem.GoodName }}</div>
                                    <div class="project-Name in-one-line">{{ optionItem.AutoSerise }}</div>
                                    <div class="project-Name" v-if="changeCodeConfig">{{ optionItem.GoodCode }}</div>
                                    <div class="project-iven" v-if="isInvenShow">{{ optionItem.DynaInven }}</div>
                                </div>
                            </el-option>
                            <el-option v-if="loading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="GoodName" title="配件名称" edit-render resizable>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <div :class="['div-padding-12', { 'special-border': !row.GoodName }]" @click="focusHandle('partsNameSelect')">{{ row.GoodName }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input
                            v-if="scope.row.IsNew"
                            size="small"
                            placeholder="配件名称"
                            v-model="scope.row.GoodName"
                            :disabled="dataReadonly || (scope.row.hasLock && lastRowIndex !== scope.rowIndex)"
                        />
                        <el-select
                            v-else
                            ref="partsNameSelect"
                            style="width: 100%"
                            allow-create
                            size="small"
                            v-model="scope.row.GoodName"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="配件名称"
                            @focus="hideMsg"
                            @change="nameChange($event, scope.rowIndex)"
                            @visible-change="apNameVisibleChange($event)"
                            :remote-method="searchName"
                            v-select-scroll-more="searchNameLoad"
                            @keyup.enter.native="keyEvent($event, 'GoodName')"
                            @keyup.right.native="keyEvent($event, 'GoodName')"
                            @keyup.left.native="keyEvent($event, 'GoodName')"
                            :disabled="dataReadonly || (scope.row.hasLock && lastRowIndex !== scope.rowIndex)"
                            popper-class="el-select-style-gray"
                        >
                            <el-option
                                v-for="optionItem in nameList"
                                :key="optionItem.EntpTempGoodsId"
                                :data-msg="optionItem"
                                :label="optionItem.GoodName"
                                :value="optionItem.GoodName"
                            >
                                <div class="option-content">
                                    <div class="project-Name">{{ optionItem.GoodName }}</div>
                                    <div class="project-Name">{{ optionItem.APCode }}</div>
                                    <div class="project-Name in-one-line">{{ optionItem.AutoSerise }}</div>
                                    <div class="project-Name" v-if="changeCodeConfig">{{ optionItem.GoodCode }}</div>
                                    <div class="project-iven" v-if="isInvenShow">{{ optionItem.DynaInven }}</div>
                                </div>
                            </el-option>
                            <el-option v-if="loading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="AutoSeriseItem" title="车型" edit-render resizable>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <el-tooltip effect="dark" :content="row.AutoSerise" :disabled="!row.AutoSerise" placement="top">
                            <div :class="['div-padding-12', { 'special-border': !row.AutoSerise }]" @click="focusHandle('autoSeriseSelect')">
                                {{ row.AutoSerise }}
                            </div>
                        </el-tooltip>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input
                            size="small"
                            v-model="scope.row.AutoSerise"
                            placeholder="车系"
                            v-if="scope.row.IsNew"
                            :disabled="dataReadonly || (scope.row.hasLock && lastRowIndex !== scope.rowIndex)"
                        ></el-input>
                        <el-select
                            v-else
                            style="width: 100%"
                            ref="autoSeriseSelect"
                            allow-create
                            size="small"
                            v-model="scope.row.AutoSerise"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="车系"
                            @focus="hideMsg"
                            @change="serieChange($event, scope.rowIndex)"
                            @visible-change="autoSeriseVisibleChange($event)"
                            :remote-method="searchAutoSerie"
                            v-select-scroll-more="searchAutoSerieLoad"
                            @keyup.enter.native="keyEvent($event, 'AutoSerise')"
                            @keyup.right.native="keyEvent($event, 'AutoSerise')"
                            @keyup.left.native="keyEvent($event, 'AutoSerise')"
                            :disabled="dataReadonly || (scope.row.hasLock && lastRowIndex !== scope.rowIndex)"
                            popper-class="el-select-style-gray"
                        >
                            <el-option :loading="true" v-for="item in seriesList" :key="item.SeriesId" :label="item.SeriesName" :value="item.SeriesName">
                                <div class="option-content">
                                    <div class="project-Name">{{ item.SeriesName }}</div>
                                    <div class="project-Name">{{ item.GoodName }}</div>
                                    <div class="project-Name">{{ item.APCode }}</div>
                                    <div class="project-Name" v-if="changeCodeConfig">{{ item.GoodCode }}</div>
                                    <div class="project-iven" v-if="isInvenShow">{{ item.DynaInven }}</div>
                                </div>
                            </el-option>
                            <el-option v-if="loading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="Origin" title="产地" v-if="isOriginShow" width="160" :edit-render="{ autofocus: '.el-input__inner' }" resizable key="origin">
                    <template v-slot="{ row }">
                        <div class="div-padding-12" @click="focusHandle('originRef')">{{ row.Origin }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input
                            ref="originRef"
                            size="small"
                            v-model="scope.row.Origin"
                            @keyup.right.native="keyEvent($event, 'Origin')"
                            @keyup.left.native="keyEvent($event, 'Origin')"
                            @focus="selectAutoHandle('originRef')"
                            :disabled="dataReadonly"
                        ></el-input>
                    </template>
                </ux-table-column>
                <ux-table-column field="Size" title="规格" v-if="isSizeShow" width="160" resizable key="Size">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Size }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Count" title="数量" width="100" :edit-render="{ autofocus: '.el-input__inner' }" resizable>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Count }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input-number
                            class="salecounts-input-cell"
                            style="width: 100%"
                            type="number"
                            ref="countRef"
                            :min="1"
                            :precision="0"
                            controls-position="right"
                            size="small"
                            v-model="scope.row.Count"
                            :disabled="dataReadonly"
                            @keyup.enter.native="keyEvent($event, 'Count')"
                            @keyup.right.native="keyEvent($event, 'Count')"
                            @keyup.left.native="keyEvent($event, 'Count')"
                            @focus="selectAutoHandle('countRef')"
                        ></el-input-number>
                    </template>
                </ux-table-column>
                <ux-table-column field="Unit" title="单位" width="100" edit-render resizable>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['div-padding-12', { 'special-border': !row.Unit }]" @click="focusHandle('unitSelect')">{{ row.Unit }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select
                            ref="unitSelect"
                            default-first-option
                            size="small"
                            v-model="scope.row.Unit"
                            filterable
                            clearable
                            remote
                            @focus="hideMsg"
                            reserve-keyword
                            placeholder="单位"
                            @visible-change="unitVisibleChange($event)"
                            :disabled="dataReadonly"
                            popper-class="el-select-style-gray"
                        >
                            <el-option v-for="optionItem in unitList" :key="optionItem.Value" :label="optionItem.Value" :value="optionItem.Value"></el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="MarketPrice" title="销售价" width="120" :edit-render="{ autofocus: '.el-input__inner' }" resizable>
                    <template v-slot:header="{ column }">
                        <el-tooltip effect="dark" placement="bottom">
                            <div slot="content">
                                当配件商品有过销售历史且该客户有购买历史时，显示该客户购买配件商品的最新销售价格； <br />若配件商品从未销售过，则不显示数值
                            </div>
                            <span>
                                <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                                <span class="color-red">*</span>
                            </span>
                        </el-tooltip>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <div :class="['div-padding-12', { 'special-border': !row.MarketPrice }]">
                            <span>{{ row.MarketPrice }}</span>
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input-number
                            style="width: 100%"
                            ref="marketPirceRef"
                            class="sales-input-cell"
                            :min="0"
                            :precision="2"
                            :step="0.01"
                            controls-position="right"
                            size="small"
                            v-model="scope.row.MarketPrice"
                            placeholder="销售价"
                            :disabled="dataReadonly"
                            @keyup.enter.native="addItem(true)"
                            @keyup.left.native="keyEvent($event, 'MarketPrice')"
                            @keyup.right.native="keyEvent($event, 'MarketPrice')"
                            @focus="selectAutoHandle('marketPirceRef')"
                        ></el-input-number>
                    </template>
                </ux-table-column>
                <ux-table-column field="ReferencePrice" title="参考价" width="120" resizable>
                    <template v-slot:header="{ column }">
                        <el-tooltip effect="dark" placement="bottom">
                            <div slot="content">当配件商品有过报价历史时，显示配件商品的最新报价价格； <br />若配件商品从未报价给客户时，则显示配件商品的零售价格</div>
                            <span>
                                <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                            </span>
                        </el-tooltip>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">
                            <img
                                src="@/assets/images/quote.png"
                                title="报价历史"
                                style="width: 25px; height: 25px"
                                v-if="row.EntpTempGoodsId"
                                @click.stop="showQuoteHistorie(row.EntpTempGoodsId)"
                            />
                            <img
                                src="@/assets/images/cus.png"
                                style="width: 25px; height: 25px; margin-right: 4px"
                                title="销售历史"
                                v-if="row.EntpTempGoodsId"
                                @click.stop="showHistoryDialog(row.EntpTempGoodsId)"
                            />
                            {{ row.ReferencePrice }}
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="jhj" title="进货价" width="90" resizable>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.CostPrice }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input-number :min="0" :precision="2" :step="0.01" controls-position="right" size="small" v-model="scope.row.CostPrice"></el-input-number>
                    </template>
                </ux-table-column>
                <ux-table-column field="ly" title="留余" width="80" resizable>
                    <template v-slot:header="{ column }">
                        <el-tooltip effect="dark" placement="bottom">
                            <div slot="content">
                                {{ isAddWaitIn ? '留余=总库存数－总待出数＋总待入数' : '留余=总库存数－总待出数' }}
                                <br />注意：此处已统计退货商品的数量
                                <br />
                            </div>
                            <span>
                                <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                            </span>
                        </el-tooltip>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">
                            <el-tooltip
                                effect="dark"
                                :content="
                                    '待入仓(' +
                                    row.POrderWaitInQuantity +
                                    '）  待出仓(' +
                                    row.OrderWaitOutQuantity +
                                    '）  库存(' +
                                    (submitData.WarehouseId ? row.StorageInventory : row.Inventory) +
                                    '）'
                                "
                                placement="top"
                            >
                                <span
                                    :class="{
                                        'color-red':
                                            (submitData.WarehouseId ? row.StorageInventory : row.Inventory) +
                                                (isAddWaitIn ? row.POrderWaitInQuantity : 0) -
                                                row.OrderWaitOutQuantity <=
                                            0
                                    }"
                                >
                                    {{
                                        (submitData.WarehouseId ? row.StorageInventory : row.Inventory) +
                                        (isAddWaitIn ? row.POrderWaitInQuantity : 0) -
                                        row.OrderWaitOutQuantity
                                    }}
                                </span>
                            </el-tooltip>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="bz" title="备注" width="120" edit-render resizable>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Remark }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input
                            size="small"
                            ref="remarkRef"
                            class="remark-input-cell"
                            v-model="scope.row.Remark"
                            :disabled="dataReadonly"
                            @keyup.enter.native="addItem(true)"
                            @keyup.left.native="keyEvent($event, 'Remark')"
                        ></el-input>
                    </template>
                </ux-table-column>
                <ux-table-column title="操作" width="120">
                    <template v-slot="{ row, rowIndex }">
                        <div class="operate" v-if="!dataReadonly">
                            <el-button
                                size="small"
                                @click="delItem(rowIndex)"
                                icon="el-icon-delete"
                                v-if="dataList.length !== 1 && !(submitData.CreatorType != 0 && type == 2)"
                            ></el-button>
                            <el-button
                                size="small"
                                type="primary"
                                @click="addItem(true)"
                                icon="el-icon-plus"
                                v-if="rowIndex + 1 === dataList.length && !(submitData.CreatorType != 0 && type == 2)"
                            ></el-button>
                            <el-button
                                size="small"
                                @click="upLock(rowIndex)"
                                :icon="row.hasLock ? 'el-icon-lock' : 'el-icon-unlock'"
                                v-if="isLock && lastRowIndex !== rowIndex"
                            ></el-button>
                        </div>
                    </template>
                </ux-table-column>
            </ux-grid>
            <div class="bottom-div" v-if="!dataReadonly" @click="hideMsg">
                <el-button size="small" class="search-btn btn-primary" @click.stop="submitForm()" :disabled="saving">提交报价</el-button>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" :title="customerEditType == 2 ? '编辑客户' : '新增客户'" :visible.sync="dialogVisible" width="1000px">
            <div class="dialog-content" v-if="dialogVisible">
                <customerEdit ref="customerEdit" :cusId="submitData.EntpCusId" :type="customerEditType" source="1" @closeDialog="closeDialog"></customerEdit>
            </div>
        </el-dialog>
        <!--   配件信息     -->
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
        <!--   搜索配件    -->
        <el-dialog
            :close-on-click-modal="false"
            title="搜索配件"
            :visible.sync="searchVisible"
            width="1200px"
            v-dialog-drag
            :modal="false"
            lock-scroll
            id="search-dialog"
        >
            <div v-if="searchVisible">
                <searchAP
                    :dragType="1"
                    dragSign="bjEdit"
                    :Source="0"
                    :EntpCusId="submitData.EntpCusId"
                    :EntpCusName="submitData.EntpCusName"
                    :StorageId="submitData.WarehouseId"
                    @chooseAllAPsHandle="chooseAllAPsHandle"
                    @closeDialog="closeSearchDialog"
                    :SelectedData="selectedData"
                ></searchAP>
            </div>
        </el-dialog>
        <!--    销售历史    -->
        <el-dialog :close-on-click-modal="false" title="销售历史" :visible.sync="historyVisible" width="1200px">
            <div v-if="historyVisible">
                <APHistory
                    :EntpCusId="submitData.EntpCusId"
                    :EntpTempGoodsId="EntpTempGoodsIdEdit"
                    :EntpCusName="submitData.EntpCusName"
                    @closeDialog="closeHistoryDialog"
                ></APHistory>
            </div>
        </el-dialog>
        <!--    报价历史    -->
        <el-dialog :close-on-click-modal="false" title="报价历史" :visible.sync="historyQuoteVisible" width="1200px">
            <div v-if="historyQuoteVisible">
                <APQuoteHistory
                    :EntpCusId="submitData.EntpCusId"
                    :EntpTempGoodsId="EntpTempGoodsIdEdit"
                    :EntpCusName="submitData.EntpCusName"
                    @closeDialog="closeQuoteHistoryDialog"
                ></APQuoteHistory>
            </div>
        </el-dialog>
        <el-progress v-if="searchApParams._visible" class="saveProgress" type="circle" :percentage="searchApParams._percentage" />
        <!-- 新增库存 -->
        <transInventory v-if="addAPVisible" :dialogFormVisible="addAPVisible" :apParams="addAPParams" @closeDialog="closeAddAPDialog"></transInventory>
    </div>
</template>
<script>
import customerEdit from '@/components/business/customerManage/customerEdit';
import APMsg from '@/components/common/APMsg';
import searchAP from '@/components/common/searchAP';
import APHistory from '@/components/common/APHistory';
import APQuoteHistory from '@/components/common/APQuoteHistory';
import mixin from '@/mixins/mixin';
import breadcrumb from '@/components/common/breadcrumb';
import transInventory from '@/components/business/search/transInventory';
export default {
    mixins: [mixin],
    name: '',
    components: {
        customerEdit,
        APMsg,
        searchAP,
        APHistory,
        APQuoteHistory,
        breadcrumb,
        transInventory
    },
    data() {
        let checkPositive = this.$util.checkPositive;
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            isCheckCode: true,
            userMsg: userMsg,
            saving: false,
            needConfirm: true,
            dialogVisible: false,
            searchVisible: false,
            historyVisible: false,
            historyQuoteVisible: false,
            APMsgVisible: false,
            EntpTempGoodsIdEdit: '',
            showHistory: false,
            historyNoData: true,
            loading: false,
            showOrderMsg: true,
            canRequest: true,
            customerEditType: 1,
            dataReadonly: false,
            historyStyle: {
                top: ''
            },
            editIndex: -1,
            submitData: {
                QuoteId: '',
                UserId: userMsg.EmployeeId,
                EntpCusId: '',
                NeedTime: '',
                Remark: '',
                PriceSumShip: '',
                ITime: '',
                QTime: '',
                IsSubmitReview: false,
                CreatorType: 0,
                WarehouseId: '',
                OId: '', // 销售退货单id/销售单id，转报价使用
                DetailList: []
            },
            Limit: 10,
            download_url: this.$util.QN_URL_BASE,
            customerList: [],
            codeList: [],
            nameList: [],
            seriesList: [],
            dataList: [],
            historyList: [],
            unitList: [],
            type: 1, //  1 查看 2 编辑 3 新增 4 销售转报价（目前没有用到） 5复制报价单 6销售退货转报价
            id: '',
            pageTitle: '',
            rules: {
                EntpCusId: [{ required: true, message: '请选择客户', trigger: 'blur' }],
                PriceSumShip: [{ required: false, validator: checkPositive, trigger: 'blur' }]
            },

            infiniteListHeight: 0, // 列表高度，在收起信息栏时进行实时计算
            selectedData: [],
            apcodeSource: null,
            // 是否预先加载汽配编码列表数据
            isPreloadApCodeList: false,
            // 用于客户名称列表，分页搜索
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 用于汽配编码列表，分页搜索功能
            codeForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 用于配件名称列表，分页搜索功能
            nameForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 用于车型列表，分页搜索功能
            autoSerieForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 加锁：选择商品完成回车或点加号后触发锁定不可修改
            hasLock: false,
            // 搜索配件弹框返回参数
            searchApParams: {
                _visible: false,
                _percentage: 0,
                _limit: 500,
                // 总数量
                _totalCount: 0
            },
            // 功能配置项：初始数量值
            initNumber: 1,
            isAddWaitIn: true,
            // 新增库存
            addAPVisible: false,
            addAPParams: {},
            changeCodeConfig: true,
            warehouseList: [], //仓库地址
            warehouseType: '',
            isInvenShow: false,
            isOriginShow: false, //产地
            isSizeShow: false //规格
        };
    },
    beforeRouteLeave(to, from, next) {
        this.$util.confirmBeforeLeave(to, from, next, this);
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
        this.getConfigByCodes();
    },
    mounted() {
        this.id = this.$route.query.id;
        this.submitData.QuoteId = this.$route.query.id;
        this.type = this.$route.query.type;
        let salesbjOrder = this.$util.getLocalStorage('salesbjOrder');
        let datalist = this.$util.getLocalStorage('salesbjOrder_dataList');
        if (this.type == 1) {
            this.pageTitle = '查看报价单';
            this.dataReadonly = true;
            this.getBJOrder();
        } else if (this.type == 2) {
            this.pageTitle = '编辑报价单';
            if (salesbjOrder && datalist && datalist.length > 0) {
                this.getDataFromChace();
            } else {
                this.getBJOrder();
            }
        } else if (this.type == 3) {
            this.pageTitle = '新增报价单';
            if (salesbjOrder && datalist && datalist.length > 0) {
                this.getDataFromChace();
            } else {
                this.getdefaultWarehouses();
                this.addItem(false);
            }
        } else if (this.type == 4) {
            this.pageTitle = '销售转报价单';
            if (salesbjOrder && datalist && datalist.length > 0) {
                this.getDataFromChace();
            } else {
                this.submitData.OId = this.$route.query.sid;
                this.getSalesOrder();
            }
        } else if (this.type == 5) {
            this.pageTitle = '复制订单';
            if (salesbjOrder && datalist && datalist.length > 0) {
                this.getDataFromChace();
            } else {
                this.getBJOrder();
            }
        } else if (this.type == 6) {
            this.pageTitle = '销售退货转报价';
            if (salesbjOrder && datalist && datalist.length > 0) {
                this.getDataFromChace();
            } else {
                this.submitData.OId = this.$route.query.rid;
                this.getSaleRetrunOrder();
            }
        }
        //当表格出现滚动条后，编辑最后一条数据时，点击滚动条内底部的空白处单元格的编辑状态没有去除
        //为了解决这个bug在表格的父级监听点击事件来清除单元格激活状态
        let tablebody = document.querySelector('.elx-table--body-wrapper');
        if (tablebody) tablebody.addEventListener('click', this.clearActived, false);

        window.onresize = () => {
            this.resetHeight();
        };
        setTimeout(() => {
            this.resetHeight();
        }, 0);
    },
    computed: {
        // 列表高度
        infiniteTableHeight() {
            let bottomHeight = this.type == 1 ? 24 : 78;
            return this.infiniteListHeight - bottomHeight;
        },
        // 是否加锁
        isLock() {
            return this.hasLock && [2, 3, 5].includes(this.type * 1);
        },
        // 列表数据最后一行下标
        lastRowIndex() {
            return Array.isArray(this.dataList) ? this.dataList.length - 1 : 0;
        }
    },
    methods: {
        handleKeyEvent(e) {
            let key = window.event.keyCode;
            if (key === 107 || key === 187) {
                if (!this.searchVisible) this.addItem(false);
            }
            if (key == 113) {
                this.searchVisible = true;
            }
        },
        getConfigByCodes() {
            let codes = ['ddhhm', 'kdyjz', 'kdbjsd', 'spmrsl', 'lybsdr', 'ddkcs', 'kdspcd', 'kdspgg', 'xzqpbmdwyx'];
            this.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        let rValue = data[i].RValue;
                        switch (code) {
                            case 'ddhhm': //是否展示互换码
                                this.changeCodeConfig = result;
                                break;
                            case 'kdyjz': // 获取预加载商品数据的功能设置结果
                                this.isPreloadApCodeList = result;
                                break;
                            case 'kdbjsd': // 选择商品完成回车或点加号后触发锁定不可修改
                                this.hasLock = result;
                                break;
                            case 'spmrsl': // 获取客户配置的初始数量值
                                if (result && !isNaN(rValue)) this.initNumber = rValue;
                                break;
                            case 'lybsdr': //获取留余的计算方式
                                this.isAddWaitIn = !result;
                                break;
                            case 'ddkcs':
                                this.isInvenShow = result;
                                break;
                            case 'kdspcd': //是否出现产地
                                this.isOriginShow = result;
                                break;
                            case 'kdspgg': //是否出现规格
                                this.isSizeShow = result;
                                break;
                            case 'xzqpbmdwyx': //是否检测编码重复
                                this.isCheckCode = result;
                                break;
                        }
                    }
                }
            });
        },
        // 关闭新增库存弹框
        async closeAddAPDialog(result, row) {
            this.addAPVisible = false;
            if (!row) return;
            this.$set(this.dataList, this.addAPParams.index, {
                ...row,
                Count: this.initNumber,
                State: 0,
                CostPrice: row.CostPrice, // 进货价对应成本价
                ReferencePrice: row.MarketPrice, // 参考价对应零售价
                MarketPrice: 0
            });
            this.addPageChace();
        },
        // 计算infinite-list高度
        resetHeight() {
            let listObj = document.getElementById('infinite-list');
            if (!listObj) return;
            let clientObj = listObj.getBoundingClientRect();
            this.infiniteListHeight = window.innerHeight - clientObj.top - 10;
        },
        getConfigData() {
            this.$util.searchGoodsUnit().then(res => {
                this.unitList = res;
            });
        },
        // 搜索
        showSearch() {
            if (this.dataList.length > 0) {
                this.selectedData = [];
                this.dataList.forEach(item => {
                    if (item.EntpTempGoodsId) this.selectedData.push(item.EntpTempGoodsId);
                });
            }
            this.searchVisible = true;
        },
        // 搜索配件弹框 - 确认筛选结果按钮操作
        chooseAllAPsHandle(data) {
            data.searchData.CheckSalesOutWHCout = false;
            this.searchVisible = false;
            this.searchApParams = {
                ...data.searchData,
                limit: this.searchApParams._limit,
                _visible: true,
                _percentage: 0,
                _limit: this.searchApParams._limit,
                _totalCount: data.searchData.limit
            };
            this.loopSearch();
        },
        // 开始循环
        async loopSearch() {
            const { data } = await this.$util.axiosPost({
                url: '/api/EntpGoods/GetFullDataGoodsListForOrder',
                data: this.searchApParams,
                hideLoading: true
            });
            this.searchApParams._percentage = parseInt(((this.searchApParams.page * this.searchApParams.limit) / this.searchApParams._totalCount) * 100);
            this.searchApParams.page += 1;
            let _stop = !data || data.length < this.searchApParams._limit;
            this.closeSearchDialog(data);
            if (_stop) {
                this.searchApParams._percentage = 100;
                this.searchApParams._visible = false;
            } else {
                this.loopSearch();
            }
        },
        // noClose 表示不关闭弹框
        closeSearchDialog(items, noClose = false) {
            let that = this;
            let itemList = [...items];
            if (itemList.length == 0) {
                if (!noClose) {
                    that.searchVisible = false;
                    return;
                }
            }
            let newGoodsList = [];
            for (let i = 0; i < itemList.length; i++) {
                let item = itemList[i];
                let goodsIdx = that.dataList.findIndex(e => item.APCode == e.APCode);
                if (goodsIdx === -1) {
                    let newGoods = {
                        ReferencePrice: item.ReferencePrice,
                        EntpTempGoodsId: item.EntpTempGoodsId,
                        APCode: item.APCode,
                        GoodName: item.GoodName,
                        AutoSerise: item.AutoSerise,
                        Count: this.initNumber,
                        Price: item.Price ? item.Price : 0,
                        MarketPrice: item.LatestPrice > 0 ? item.LatestPrice : '',
                        Unit: item.Unit,
                        Remark: item.Remark,
                        State: 0,
                        CostPrice: 0,
                        Inventory: item.Inventory,
                        OrderWaitOutQuantity: item.OrderWaitOutQuantity,
                        POrderWaitInQuantity: item.POrderWaitInQuantity,
                        StorageInventory: item.StorageInventory,
                        Origin: item.Origin,
                        Size: item.Size
                    };
                    if (!isNaN(item._count)) {
                        newGoods.Count = item._count;
                    }
                    if (!isNaN(item._price)) {
                        newGoods.MarketPrice = item._price;
                    }
                    newGoodsList.push(newGoods);
                } else {
                    // 重复数据并且从搜索配件双击回来时修改数量和销售价
                    if (noClose) {
                        that.dataList[goodsIdx].Count = item._count;
                        that.dataList[goodsIdx].MarketPrice = item._price;
                    }
                }
            }
            //判断最后一条数据是否空值，是的话移到最后
            if (that.dataList.length == 0) {
                that.dataList = that.dataList.concat(newGoodsList);
            } else {
                let lastItem = that.dataList[that.dataList.length - 1];
                if (!lastItem.APCode && !lastItem.GoodName) {
                    that.dataList.splice(that.dataList.length - 1, 1);
                    that.dataList = that.dataList.concat(newGoodsList);
                    that.dataList.push(lastItem);
                } else {
                    that.dataList = that.dataList.concat(newGoodsList);
                }
            }
            if (!noClose) {
                that.searchVisible = false;
            }
            that.$nextTick(() => {
                if (that.$refs[`countRef`]) {
                    that.$refs[`countRef`][0].focus();
                }
            });
            that.addPageChace();
        },
        // 配件信息
        showAPMsgDialog(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.APMsgVisible = true;
            }
        },
        closeAPMsgDialog(edit) {
            this.APMsgVisible = false;
            if (edit) {
                this.getOrderDetail();
            }
        },
        // 配件信息
        hideMsg() {
            this.showOrderMsg = false;
            setTimeout(() => {
                this.resetHeight();
            }, 100);
        },
        showMsg() {
            this.showOrderMsg = true;
            setTimeout(() => {
                this.resetHeight();
            }, 100);
        },
        closeDialog(edit, id, name) {
            let that = this;
            if (edit) {
                if (id) {
                    let currCust = that.customerList.find(e => e.EntpCusId == id);
                    if (!currCust) {
                        that.customerList.push({
                            EntpCusId: id,
                            EntpCusName: name
                        });
                    } else {
                        that.submitData.EntpCusName = name;
                        currCust.EntpCusName = name;
                        that.submitData.EntpCusId = '';
                    }

                    that.$nextTick(() => {
                        that.submitData.EntpCusId = id;
                        if (!that.submitData.EntpCusName) that.submitData.EntpCusName = name;
                    });
                } else {
                    that.searchCustomer();
                }
            }
            that.dialogVisible = false;
        },
        addCustomer(type) {
            this.customerEditType = type;
            this.dialogVisible = true;
        },
        customerChange(value) {
            let that = this;
            if (!value) that.submitData.EntpCusName = '';
            else {
                let currCust = that.customerList.find(e => e.EntpCusId == value);
                if (currCust) {
                    that.submitData.EntpCusName = currCust.EntpCusName;
                }
            }
        },
        //获取销售转报价单的数据
        getSalesOrder() {
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleOrder/GetOrderforQuote',
                    data: {
                        EntpCusOId: this.submitData.OId
                    }
                })
                .then(res => {
                    let data = res.data;
                    this.customerList.push({
                        EntpCusId: data.EntpCusId,
                        EntpCusName: data.EntpCusName
                    });

                    this.submitData = data;
                    if (data.Warehouse) {
                        this.warehouseList.push({
                            WarehouseId: data.Warehouse.WarehouseId,
                            WarehouseName: data.Warehouse.WarehouseName,
                            Type: data.Warehouse.Type
                        });
                        this.warehouseType = data.Warehouse.Type;
                        this.$set(this.submitData, 'WarehouseId', data.Warehouse.WarehouseId);
                        this.$set(this.submitData, 'WarehouseType', data.Warehouse.Type);
                        this.$set(this.submitData, 'WarehouseName', data.Warehouse.WarehouseName);
                    }
                    data.DetailList.forEach(ele => {
                        ele.hasLock = this.hasLock;
                    });
                    this.dataList = data.DetailList;
                });
        },
        //获取询价单详情
        getBJOrder() {
            this.$util
                .axiosGet({
                    url: '/api/EntpQuotationOrder/GetQuotationOrder',
                    data: {
                        QuoteId: this.id
                    }
                })
                .then(res => {
                    let data = res.data;
                    data.QuoteId = this.id;
                    this.customerList.push({
                        EntpCusId: data.EntpCusId,
                        EntpCusName: data.EntpCusName
                    });
                    this.submitData = data;
                    if (data.Warehouse) {
                        this.warehouseList.push({
                            WarehouseId: data.Warehouse.WarehouseId,
                            WarehouseName: data.Warehouse.WarehouseName,
                            Type: data.Warehouse.WarehouseType
                        });
                        this.warehouseType = data.Warehouse.WarehouseType;
                        this.$set(this.submitData, 'WarehouseId', data.Warehouse.WarehouseId);
                        this.$set(this.submitData, 'WarehouseType', data.Warehouse.WarehouseType);
                        this.$set(this.submitData, 'WarehouseName', data.Warehouse.WarehouseName);
                    }
                    data.DetailList.forEach(ele => {
                        ele.hasLock = this.hasLock;
                    });
                    this.dataList = data.DetailList;
                });
        },
        //获取退货转报价单的数据
        getSaleRetrunOrder() {
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleReturnOrder/GetOrderforQuote',
                    data: {
                        SReturnId: this.submitData.OId
                    }
                })
                .then(res => {
                    let data = res.data;
                    this.customerList.push({
                        EntpCusId: data.EntpCusId,
                        EntpCusName: data.EntpCusName
                    });
                    this.submitData = data;
                    if (data.Warehouse) {
                        this.warehouseList.push({
                            WarehouseId: data.Warehouse.WarehouseId,
                            WarehouseName: data.Warehouse.WarehouseName,
                            Type: data.Warehouse.WarehouseType
                        });
                        this.warehouseType = data.Warehouse.WarehouseType;
                        this.$set(this.submitData, 'WarehouseId', data.Warehouse.WarehouseId);
                        this.$set(this.submitData, 'WarehouseType', data.Warehouse.WarehouseType);
                        this.$set(this.submitData, 'WarehouseName', data.Warehouse.WarehouseName);
                    }
                    if (data.DetailList && data.DetailList.length > 0) {
                        data.DetailList.forEach(ele => {
                            ele.hasLock = this.hasLock;
                        });
                        this.dataList = data.DetailList;
                    } else {
                        this.addItem(false);
                    }
                });
        },
        // 提交询价单
        submitForm() {
            if (this.saving) return;
            let _dataList = this.dataList;
            if (!this.submitData.EntpCusId) {
                this.$util.warningMsg('请选择客户');
                return;
            }
            if (this.submitData.PriceSumShip < 0) {
                this.$util.warningMsg('运费不能小于0');
                return;
            }
            for (let i = 0; i < _dataList.length; i++) {
                if (!_dataList[i].APCode) {
                    this.$util.warningMsg('请填写配件编码');
                    return;
                }
                if (!_dataList[i].GoodName) {
                    this.$util.warningMsg('请填写配件名称');
                    return;
                }
                if (_dataList[i].State != 0) {
                    this.$util.warningMsg('商品【' + _dataList[i].GoodName + '（' + _dataList[i].APCode + '）' + '】已删除');
                    return;
                }
                if (!_dataList[i].AutoSerise) {
                    this.$util.warningMsg('请填写车型');
                    return;
                }
                if (!_dataList[i].Unit) {
                    this.$util.warningMsg('请填写单位');
                    return;
                }
                if (_dataList[i].CostPrice && _dataList[i].CostPrice < 0) {
                    this.$util.warningMsg('进货价不能小于0');
                    return;
                }
                if (!_dataList[i].MarketPrice || Number(_dataList[i].MarketPrice) <= 0) {
                    this.$util.warningMsg(`请给序号为 ${i + 1} 的商品填写正确的销售价`);
                    return;
                }
            }
            this.submitData.DetailList = _dataList;

            let checkRepeat = this.checkRepeatAndReturnData();
            if (checkRepeat.hasRepeat) {
                this.$confirm('订单含有重复商品项，是否需要累加', '', {
                    type: 'error',
                    distinguishCancelAndClose: true
                })
                    .then(() => {
                        // 覆盖数据
                        this.dataList = checkRepeat.row;
                        this.submitData.DetailList = checkRepeat.row;
                        this.submitFormAgain();
                    })
                    .catch(() => {});
            } else {
                this.submitFormAgain();
            }
        },
        submitFormAgain() {
            this.saving = true;
            let url = '/api/EntpQuotationOrder/SaveQuotationOrder';
            if (+this.type == 4) url = '/api/EntpQuotationOrder/TransformSaleOrder';
            if (+this.type == 5) url = '/api/EntpQuotationOrder/RebuildEntpCustQOrder';
            if (+this.type == 6) url = '/api/EntpQuotationOrder/TransformSaleReturnOrder';
            this.$util
                .axiosPost({
                    url: url,
                    data: this.submitData
                })
                .then(() => {
                    this.needConfirm = false;
                    this.$util.successMsg('提交报价单成功');
                    //清除订单缓存
                    this.removePageChace();
                    //编辑后列表页面需要刷新
                    this.$store.commit('updateNeedRefresh', true);
                    setTimeout(() => {
                        this.saving = false;
                        this.$router.push('/salesManage/quotation');
                    }, 2000);
                })
                .catch(() => {
                    this.saving = false;
                });
        },
        // 检查是否有重复项及返回已合并数量的数据
        checkRepeatAndReturnData() {
            let [list, row, hasRepeat] = [this.submitData.DetailList, [], false];
            if (this.isCheckCode) {
                list.forEach(item => {
                    let index = row.findIndex(f => f.APCode === item.APCode);
                    if (index > -1) {
                        hasRepeat = true;
                        row[index].Count = Number(row[index].Count) + Number(item.Count);
                    } else {
                        row.push(Object.assign({}, item));
                    }
                });
            } else {
                list.forEach(item => {
                    let index = row.findIndex(f => f.EntpTempGoodsId === item.EntpTempGoodsId);
                    if (index > -1) {
                        hasRepeat = true;
                        row[index].Count = Number(row[index].Count) + Number(item.Count);
                    } else {
                        row.push(Object.assign({}, item));
                    }
                });
            }
            return {
                hasRepeat,
                row
            };
        },
        // 删除某行
        delItem(index) {
            if (this.dataList.length != 1) {
                this.dataList.splice(index, 1);
            }
            this.addPageChace();
        },
        // 添加一行
        addItem(addPageChace) {
            if (this.dataReadonly) return;
            let _dataList = this.dataList;
            for (let i = 0; i < _dataList.length; i++) {
                if (!_dataList[i].APCode) {
                    this.$util.warningMsg('请填写配件编码');
                    return;
                }
                if (!_dataList[i].GoodName) {
                    this.$util.warningMsg('请填写配件名称');
                    return;
                }
                if (!_dataList[i].AutoSerise) {
                    this.$util.warningMsg('请填写车型');
                    return;
                }
                if (!_dataList[i].Unit) {
                    this.$util.warningMsg('请填写单位');
                    return;
                }
            }

            // 上锁
            if (this.isLock) {
                this.dataList.forEach(ele => {
                    ele.hasLock = true;
                });
            }
            if (addPageChace) {
                this.addPageChace(); //添加订单缓存
            }

            this.dataList.push({
                EntpTempGoodsId: '',
                APCode: '',
                GoodName: '',
                AutoSerise: '',
                Count: this.initNumber,
                ReferencePrice: '0',
                MarketPrice: '',
                CostPrice: '0',
                Unit: '',
                Remark: '',
                IsNew: false,
                State: 0,
                Inventory: 0, //商品总数量
                StorageInventory: 0, //仓库库存数量
                OrderWaitOutQuantity: 0,
                POrderWaitInQuantity: 0,
                Origin: '',
                Size: ''
            });

            setTimeout(() => {
                this.$refs.infiniteTable.scrollToRow(this.dataList[this.dataList.length - 1]);
                this.$refs.infiniteTable.setActiveRow(this.dataList[this.dataList.length - 1]);
                if (this.dataList.length > 1) {
                    let ilEle = document.getElementsByClassName('business-content')[0];
                    ilEle.scrollTop = ilEle.scrollHeight;
                }
            }, 100);

            let that = this;
            that.$nextTick(() => {
                setTimeout(function () {
                    that.$refs.sapcode.focus();
                }, 200);
            });
        },
        // 解锁
        upLock(index) {
            this.$set(
                this.dataList,
                index,
                Object.assign({}, this.dataList[index], {
                    hasLock: !this.dataList[index].hasLock
                })
            );
        },
        // 点击展开下拉框
        focusHandle(type) {
            if (type === 'sapcode') {
                setTimeout(() => {
                    this.$refs[`sapcode`].focus();
                }, 200);
            }
            if (type === 'partsNameSelect') {
                setTimeout(() => {
                    this.$refs[`partsNameSelect`].focus();
                }, 200);
            }
            if (type === 'autoSeriseSelect') {
                setTimeout(() => {
                    this.$refs[`autoSeriseSelect`].focus();
                }, 200);
            }
            if (type === 'unitSelect') {
                setTimeout(() => {
                    this.$refs[`unitSelect`].focus();
                }, 200);
            }
            if (type === 'originRef') {
                setTimeout(() => {
                    this.$refs[`originRef`].focus();
                }, 200);
            }
        },
        // 自动选中输入框内容
        selectAutoHandle(ref) {
            this.$refs[ref].select();
        },
        // 搜索顾客
        searchCustomer(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.customerList = [];
            }
            if (this.cusForm.stopLoad) return;
            this.loading = true;
            this.$util
                .searchCustomer(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit)
                .then(data => {
                    if (!data) {
                        this.loading = false;
                        return;
                    }
                    this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                    let index = data.findIndex(e => e.EntpCusId == this.submitData.EntpCusId);
                    if (index > -1) {
                        data.splice(index, 1);
                    }

                    this.customerList = [...this.customerList, ...data];
                    // this.customerList = this.$util.uniqueArr(this.customerList, res.data);
                    //修改客户时要更新页面上展现的名称
                    // if(this.customerList.length>0){
                    //     let currCust = this.customerList.find((e) => e.EntpCusId == this.submitData.EntpCusId);
                    //     if(currCust){
                    //       this.submitData.EntpCusName = currCust.EntpCusName;
                    //     }
                    // }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustomer();
        },
        // 搜索汽配编码
        async searchCode(key) {
            // 取消请求
            if (this.apcodeSource) {
                this.apcodeSource.cancel();
            }
            if (![undefined].includes(key)) {
                this.codeForm.Page = 1;
                this.codeForm.stopLoad = false;
                this.codeForm.key = key;
                this.codeList = [];
            }
            if (this.codeForm.stopLoad) return;
            // 初始化对象
            this.apcodeSource = this.axios.CancelToken.source();
            this.loading = true;
            const { data } = await this.$util.axiosGet({
                url: '/api/EntpGoods/GetGoodsSelItemsForSaleOrder',
                data: {
                    SId: this.submitData.WarehouseId,
                    APCode: this.codeForm.key,
                    Page: this.codeForm.Page,
                    Limit: this.codeForm.Limit,
                    EntpId: this.userMsg.EntpId,
                    CId: this.submitData.EntpCusId,
                    SFrom: 'apc'
                },
                hideLoading: true,
                cancelToken: this.apcodeSource.token // 取消操作标识
            });
            this.loading = false;
            if (!data) return;
            this.codeForm.stopLoad = data.length < this.codeForm.Limit;
            this.codeList = this.$util.uniqueArr(this.codeList, data);
        },
        // 汽配编码列表，加载更多
        searchCodeLoad() {
            if (!this.loading) {
                this.codeForm.Page += 1;
                this.searchCode();
            }
        },
        // 搜索名称
        searchName(key) {
            if (![undefined].includes(key)) {
                this.nameForm.Page = 1;
                this.nameForm.stopLoad = false;
                this.nameForm.key = key;
                this.nameList = [];
            }
            if (this.nameForm.stopLoad) return;
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsSelItemsForSaleOrder',
                    data: {
                        SId: this.submitData.WarehouseId,
                        GoodName: this.nameForm.key,
                        Page: this.nameForm.Page,
                        Limit: this.nameForm.Limit,
                        EntpId: this.userMsg.EntpId,
                        CId: this.submitData.EntpCusId,
                        SFrom: 'gn'
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    if (!res.data) return;
                    this.nameForm.stopLoad = Array.isArray(res.data) && res.data.length < this.nameForm.Limit;
                    this.nameList = this.$util.uniqueArr(this.nameList, res.data);
                });
        },
        // 汽配名称列表，加载更多
        searchNameLoad() {
            this.nameForm.Page += 1;
            this.searchName();
        },
        // 搜车系
        searchAutoSerie(key) {
            if (![undefined].includes(key)) {
                this.autoSerieForm.Page = 1;
                this.autoSerieForm.stopLoad = false;
                this.autoSerieForm.key = key;
                this.seriesList = [];
            }
            if (this.autoSerieForm.stopLoad) return;
            this.loading = true;
            this.$util.searchAutoSerie(this.autoSerieForm.key, this.autoSerieForm.Page, this.autoSerieForm.Limit).then(data => {
                this.loading = false;
                if (!data) return;
                this.autoSerieForm.stopLoad = data.length < this.autoSerieForm.Limit;
                this.seriesList = this.$util.uniqueArr(this.seriesList, data);
            });
        },
        // 车系列表，加载更多
        searchAutoSerieLoad() {
            this.autoSerieForm.Page += 1;
            this.searchAutoSerie();
        },
        // 名称改变
        nameChange(value, index) {
            this.editIndex = index;
            let _list = this.nameList;
            for (let i = 0; i < _list.length; i++) {
                if (_list[i].GoodName == value) {
                    this.dataList[index].CostPrice = _list[i].CostPrice;
                    this.dataList[index].MarketPrice = _list[i].LatestPrice > 0 ? _list[i].LatestPrice : '';
                    this.dataList[index].Unit = _list[i].Unit;
                    this.dataList[index].AutoSerise = _list[i].AutoSerise;
                    this.dataList[index].ReferencePrice = _list[i].ReferencePrice;
                    this.dataList[index].State = 0;
                    this.dataList[index].Size = _list[i].Size;
                    this.dataList[index].Origin = _list[i].Origin;
                    if (!this.dataList[index].APCode) {
                        this.dataList[index].EntpTempGoodsId = _list[i].EntpTempGoodsId;
                        this.dataList[index].APCode = _list[i].APCode;
                    }
                    this.$util.getGoodsDataAfterSelItem(this.dataList[index].EntpTempGoodsId, '', this.submitData.EntpCusId, '1', false).then(data => {
                        if (data) {
                            this.dataList[index].MarketPrice = data > 0 ? data.LatestPrice : '';
                            this.dataList[index].OrderWaitOutQuantity = data.OrderWaitOutQuantity;
                            this.dataList[index].POrderWaitInQuantity = data.POrderWaitInQuantity;
                            this.dataList[index].StorageInventory = data.StorageInventory;
                            if (data.ReferencePrice) this.dataList[index].ReferencePrice = data.ReferencePrice;
                        }
                    });
                    break;
                }
            }
        },
        // 编码改变
        codeChange(value, index) {
            let isNew = true;
            this.editIndex = index;
            let _list = this.codeList;
            if (!value) {
                this.dataList[index].IsNew = false;
            }
            for (let i = 0; i < _list.length; i++) {
                let checkItem = this.isCheckCode ? _list[i].APCode : _list[i].EntpTempGoodsId;
                if (checkItem == value) {
                    this.dataList[index].APCode = _list[i].APCode;
                    this.dataList[index].EntpTempGoodsId = _list[i].EntpTempGoodsId;
                    this.dataList[index].AutoSerise = _list[i].AutoSerise;
                    this.dataList[index].CostPrice = _list[i].CostPrice;
                    this.dataList[index].MarketPrice = _list[i].LatestPrice > 0 ? _list[i].LatestPrice : '';
                    this.dataList[index].Unit = _list[i].Unit;
                    this.dataList[index].GoodName = _list[i].GoodName;
                    this.dataList[index].ReferencePrice = _list[i].ReferencePrice;
                    this.dataList[index].IsNew = false;
                    this.dataList[index].State = 0;
                    this.dataList[index].Size = _list[i].Size;
                    this.dataList[index].Origin = _list[i].Origin;
                    isNew = false;
                    this.$util.getGoodsDataAfterSelItem(this.dataList[index].EntpTempGoodsId, '', this.submitData.EntpCusId, '1', false).then(data => {
                        if (data) {
                            this.dataList[index].MarketPrice = data.LatestPrice > 0 ? data.LatestPrice : '';
                            this.dataList[index].OrderWaitOutQuantity = data.OrderWaitOutQuantity;
                            this.dataList[index].POrderWaitInQuantity = data.POrderWaitInQuantity;
                            this.dataList[index].StorageInventory = data.StorageInventory;
                            if (data.ReferencePrice) this.dataList[index].ReferencePrice = data.ReferencePrice;
                        }
                    });
                    break;
                }
            }
            if (isNew && value && this.isCheckCode) {
                let that = this;
                this.$util.elConfirm({
                    content: '要创建一个新配件吗？',
                    noMsg: true,
                    confirm() {
                        that.dataList[index].EntpTempGoodsId = '';
                        that.dataList[index].Inventory = 0;
                        that.dataList[index].MarketPrice = 0;
                        that.dataList[index].CostPrice = 0;
                        that.dataList[index].ReferencePrice = '0';
                        that.dataList[index].IsNew = true;
                        that.dataList[index].State = 0;
                        that.dataList[index].Size = '';
                        that.dataList[index].Origin = '';
                        that.$util
                            .axiosGet({
                                url: '/api/EntpGoods/GetPart',
                                data: {
                                    APCode: value
                                },
                                hideLoading: true
                            })
                            .then(res => {
                                if (res.data) {
                                    let data = res.data;
                                    that.dataList[index].APCode = data.APCode;
                                    that.dataList[index].AutoSerise = data.AutoSerise;
                                    that.dataList[index].GoodName = data.GoodName;
                                    that.dataList[index].Unit = data.Unit;
                                } else {
                                    that.addAPParams = {
                                        APCode: that.dataList[index].APCode,
                                        index: index
                                    };
                                    that.addAPVisible = true;
                                    if (that.$refs[`sapcode`]) {
                                        that.$refs[`sapcode`].blur();
                                    }
                                }
                            });
                    }
                });
            }
        },
        // 车系改变
        serieChange(value, index) {
            // this.searchAutoSerie();??
        },
        // 历史销售
        showHistoryDialog(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.historyVisible = true;
            }
        },
        closeHistoryDialog(edit) {
            this.historyVisible = false;
        },
        //报价历史
        showQuoteHistorie(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.historyQuoteVisible = true;
            }
        },
        closeQuoteHistoryDialog(edit) {
            this.historyVisible = false;
            this.historyQuoteVisible = false;
        },

        //单位下拉框显示时触发event
        unitVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.unitList.length == 0) that.getConfigData();
            }
        },
        //当供应商下拉框出现时触发
        customerVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.customerList.length <= 1) that.searchCustomer('');
            }
        },
        //当汽配件编码下拉框出现时触发
        apCodeVisibleChange(event) {
            let that = this;
            if (event && that.codeList.length == 0 && that.isPreloadApCodeList) {
                that.searchCode('');
            }
        },
        //当汽配件名称下拉框出现时触发
        apNameVisibleChange(event) {
            let that = this;
            if (event && that.nameList.length == 0 && that.isPreloadApCodeList) {
                that.searchName('');
            }
        },
        //当车系下拉框出现时触发
        autoSeriseVisibleChange(event) {
            let that = this;
            if (event && that.seriesList.length == 0 && that.isPreloadApCodeList) {
                that.searchAutoSerie('');
            }
        },
        // 设置展示行样式
        setRowStyle(param) {
            const { row, index } = param;
            let rowArr = [];
            if (this.isCheckCode) rowArr = this.dataList.filter(f => f.APCode === row.APCode);
            else rowArr = this.dataList.filter(f => f.EntpTempGoodsId === row.EntpTempGoodsId);
            if (rowArr.length > 1) {
                return `background-color: #FFE8E8`;
            }
        },
        //手动清除单元格激活状态
        clearActived(e) {
            if (e.target.className == 'elx-table--body-wrapper body--wrapper') {
                this.$refs.infiniteTable.clearActived();
            }
            e.stopPropagation();
            e.preventDefault();
        },
        // 设置展示合计数据行
        setSummaries(param) {
            const { data } = param;
            let num = 0;
            let price = 0;
            data.forEach(ele => {
                num += Number(ele.Count);
                price += Number(ele.Count * ele.MarketPrice ? (ele.Count * ele.MarketPrice).toFixed(3) : 0);
            });
            if (!this.isOriginShow && !this.isSizeShow) {
                return [['', '', '', '总数量', num, '合计', price.toFixed(2), '', '', '', '', '']];
            } else if (this.isOriginShow && this.isSizeShow) {
                return [['', '', '', '', '', '总数量', num, '合计', price.toFixed(2), '', '', '', '', '']];
            } else {
                return [['', '', '', '', '总数量', num, '合计', price.toFixed(2), '', '', '', '', '']];
            }
        },
        warehouseVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length <= 1) {
                    that.$util.getWarehouse(1).then(data => {
                        that.warehouseList = data;
                    });
                }
            }
        },
        warehouseChange(val) {
            let that = this;
            if (!val) {
                that.submitData.WarehouseName = '';
                that.dataList.forEach((e, i) => {
                    e.StorageInventory = 0;
                });
            } else {
                for (let i = 0; i < that.warehouseList.length; i++) {
                    if (val == that.warehouseList[i].WarehouseId) {
                        // that.submitData.WarehouseAddr = that.warehouseList[i].Address;
                        that.submitData.WarehouseName = that.warehouseList[i].WarehouseName;
                        break;
                    }
                }

                // 查询在这个仓库下的商品库存
                if (that.dataList) {
                    let ids = [];
                    that.dataList.forEach((e, i) => {
                        if (e.EntpTempGoodsId) ids.push(e.EntpTempGoodsId);
                    });
                    if (ids.length > 0) {
                        that.$util
                            .axiosPost({
                                url: '/api/EntpSaleOrder/GetGoodsStoragesInventorys',
                                data: {
                                    sId: val,
                                    ids: ids
                                }
                            })
                            .then(res => {
                                let data = res.data;
                                that.dataList.forEach((e, i) => {
                                    let getStorage = data.find(d => d.GoodsId == e.EntpTempGoodsId);
                                    if (getStorage) {
                                        e.StorageInventory = getStorage.Count;
                                        e.OrderWaitOutQuantity = getStorage.OrderWaitOutQuantity;
                                        e.POrderWaitInQuantity = getStorage.POrderWaitInQuantity;
                                    } else {
                                        e.StorageInventory = 0;
                                        e.OrderWaitOutQuantity = 0;
                                        e.POrderWaitInQuantity = 0;
                                    }
                                });
                            })
                            .catch(() => {});
                    }
                }
            }
        },
        //获取默认出仓仓库
        getdefaultWarehouses() {
            this.$util
                .axiosGet({
                    url: '/api/EntpQuotationOrder/GetLatestQuotationOrderWarehouse',
                    hideLoading: true
                })
                .then(res => {
                    let defaultWareshouse = res.data;
                    if (defaultWareshouse) {
                        this.warehouseList.push({
                            WarehouseId: defaultWareshouse.WarehouseId,
                            WarehouseName: defaultWareshouse.WarehouseName,
                            Address: defaultWareshouse.Address
                        });
                        this.$set(this.submitData, 'WarehouseId', defaultWareshouse.WarehouseId);
                        this.$set(this.submitData, 'WarehouseName', defaultWareshouse.WarehouseName);
                        this.$set(this.submitData, 'WarehouseAddr', defaultWareshouse.Address);
                        this.warehouseType = defaultWareshouse.WarehouseType;
                    }
                });
        },
        keyEvent(ev, code, row, index) {
            let that = this;
            if (ev.key == 'Enter') {
                if (code == 'Count' || code == 'MarketPrice') {
                    that.addItem();
                } else {
                    let inputAll = document.querySelectorAll('.salecounts-input-cell .el-input__inner');
                    inputAll[0].focus();
                }
            } else if (ev.key == 'ArrowLeft') {
                if (code == 'Count') {
                    // let inputAll = document.querySelectorAll('.elx-cell .el-select .el-input__inner');
                    // inputAll[2].focus();
                    if (that.$refs[`originRef`]) that.$refs[`originRef`].focus();
                    else that.$refs[`partsNameSelect`].focus();
                } else if (code == 'MarketPrice') {
                    let inputAll = document.querySelectorAll('.salecounts-input-cell .el-input__inner');
                    inputAll[0].focus();
                } else if (code == 'GoodName') {
                    that.$refs[`partsNameSelect`].blur();
                    let inputAll = document.querySelectorAll('.elx-cell .el-select .el-input__inner');
                    inputAll[0].focus();
                } else if (code == 'AutoSerise') {
                    that.$refs[`autoSeriseSelect`].blur();
                    let inputAll = document.querySelectorAll('.elx-cell .el-select .el-input__inner');
                    inputAll[1].focus();
                } else if (code == 'Remark') {
                    that.$refs[`remarkRef`].blur();
                    let inputAll = document.querySelectorAll('.sales-input-cell .el-input__inner');
                    inputAll[0].focus();
                } else if (code == 'Origin') {
                    that.$refs[`autoSeriseSelect`].focus();
                }
            } else if (ev.key == 'ArrowRight') {
                if (code == 'Count') {
                    let inputAll = document.querySelectorAll('.sales-input-cell .el-input__inner');
                    inputAll[0].focus();
                } else if (code == 'APCode') {
                    that.$refs[`sapcode`].blur();
                    let inputAll = document.querySelectorAll('.elx-cell .el-select .el-input__inner');
                    inputAll[1].focus();
                } else if (code == 'GoodName') {
                    that.$refs[`partsNameSelect`].blur();
                    let inputAll = document.querySelectorAll('.elx-cell .el-select .el-input__inner');
                    inputAll[2].focus();
                } else if (code == 'AutoSerise') {
                    // that.$refs[`autoSeriseSelect`].blur();
                    // let inputAll = document.querySelectorAll('.salecounts-input-cell .el-input__inner');
                    // inputAll[0].focus();
                    if (that.$refs[`originRef`]) that.$refs[`originRef`].focus();
                    else that.$refs[`countRef`].focus();
                } else if (code == 'MarketPrice') {
                    let inputAll = document.querySelectorAll('.remark-input-cell .el-input__inner');
                    inputAll[0].focus();
                } else if (code == 'Origin') {
                    that.$refs[`countRef`].focus();
                }
            }
        },
        //添加页面缓存
        addPageChace() {
            this.removePageChace();
            this.$util.setLocalStorage('salesbjOrder', this.submitData);
            this.$util.setLocalStorage('salesbjOrder_dataList', this.dataList);
        },
        //清除页面缓存
        removePageChace() {
            this.$util.clearLocalStorage('salesbjOrder');
            this.$util.clearLocalStorage('salesbjOrder_dataList');
        },
        //从缓存中读取数据
        getDataFromChace() {
            let bjModel = this.$util.getLocalStorage('salesbjOrder');
            let datalist = this.$util.getLocalStorage('salesbjOrder_dataList');
            if (bjModel) {
                this.submitData = bjModel;
                let isexit = this.customerList.find(e => e.EntpCusId == bjModel.EntpCusId);
                if (!isexit) {
                    this.customerList.push({
                        EntpCusId: bjModel.EntpCusId,
                        EntpCusName: bjModel.EntpCusName
                    });
                }
            }
            if (bjModel.WarehouseId) {
                this.warehouseList.push({
                    WarehouseId: bjModel.WarehouseId,
                    WarehouseName: bjModel.WarehouseName,
                    Type: bjModel.WarehouseType
                });
                this.warehouseType = bjModel.WarehouseType;
                this.$set(this.submitData, 'WarehouseId', bjModel.WarehouseId);
                this.$set(this.submitData, 'WarehouseType', bjModel.WarehouseType);
                this.$set(this.submitData, 'WarehouseName', bjModel.WarehouseName);
            } else {
                this.getdefaultWarehouses();
            }
            let DetailList = datalist;
            let _allNum = 0;
            let _allMoney = 0;
            for (let i = 0; i < DetailList.length; i++) {
                _allNum += Number(DetailList[i].Count);
                _allMoney += DetailList[i].Count * DetailList[i].MarketPrice ? DetailList[i].Count * DetailList[i].MarketPrice : 0;
                DetailList[i].GoodNameItem = DetailList[i].GoodName;
                DetailList[i].AutoSeriseItem = DetailList[i].AutoSerise;
                DetailList[i].hasLock = this.hasLock;
            }

            this.allMoney = _allMoney.toFixed(2);
            this.allNum = _allNum;
            this.dataList = DetailList;
        }
    }
};
</script>
<style lang="less" scoped>
.el-row {
    margin-bottom: 10px;

    &:last-child {
        margin-bottom: 10px;
    }
}
.section-title {
    display: flex;
    justify-content: space-between;
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}
.edit-ctn {
    .div-table-cell {
        padding: 0 5px;
    }
}
.option-content {
    display: flex;
    line-height: 30px;

    .project-Name {
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 12px;
    }

    .project-iven {
        width: 50px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
.btn-ctn {
    padding: 30px 0;
    margin-right: 110px;
    text-align: right;
    padding-bottom: 240px;
}
.add-btn {
    position: absolute;
    right: -40px;
    bottom: -40px;
}
.less-btn {
    position: absolute;
    right: -40px;
    top: 4px;
    z-index: 2;
}
.table-main {
    position: relative;
}
.image-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border: 1px dashed @border3Color;
}
.table-title {
    line-height: 36px;
    text-align: center;
    font-weight: bold;
}
.div-table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.table-item {
    height: 50px;
    position: relative;
}
.div-table-row {
    overflow: inherit;
    margin-left: 0;
}
.div-table-cell-code {
    position: relative;
    .row-delete {
        position: absolute;
        padding: 1px 6px;
        top: 0;
        right: 0;
        color: #fff;
        background: #ffcc66;
        border-radius: 12.5px;
    }
}
.history-main {
    position: absolute;
    left: 0;
    width: 100%;
    height: 140px;
    overflow: auto;
    padding: 10px;
    border: 1px solid @border3Color;
    background: white;
    z-index: 2;
    box-shadow: 10px 10px 5px #888888;
    .history-row {
        display: flex;
        align-items: center;
        cursor: pointer;
        overflow: inherit;
        position: relative;
        width: 100%;
        margin: -1px;
        &:hover {
            background: @border3Color;
        }
    }
    .history-cell {
        text-align: center;
        line-height: 30px;
        width: 12.5%;
        display: flex;
        align-items: center;
        justify-content: center;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
}
.history-no-data {
    text-align: center;
    font-size: 26px;
    line-height: 100px;
}
.saveProgress {
    position: absolute;
    top: 38%;
    left: 45%;
    z-index: 99999;
}
</style>
<style lang="less">
.quotation-order-infoes {
    border: 1px solid @border3Color;
    padding-top: 10px;
    margin-bottom: 10px;

    .grid-content {
        border-radius: 4px;
        min-height: 32px;
    }
    .el-form-item {
        margin-bottom: 0px;
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__label {
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__content {
        line-height: 32px !important;
        height: 32px;
        top: -1px;
    }
}
#search-dialog {
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .el-dialog__body {
        overflow: auto;
    }
}
#search-dialog::-webkit-scrollbar {
    display: none;
}
.check-code-class {
    .el-input__inner {
        border: 1px solid #f56c6c;
    }
}
.bj-edit {
    #search-dialog {
        margin-right: 35px;
    }
    .elx-table {
        .elx-body--row.row--hover,
        .elx-body--row.row--hover.row--stripe {
            background-color: #dcdee1;
        }
        .elx-table--body-wrapper {
            .elx-body--row {
                .table-sort {
                    .elx-cell {
                        padding: 4px 12px 0;
                    }
                }
                .div-padding-12 {
                    padding: 4px 12px 0;
                }
                .operate {
                    padding: 0 12px;
                }
                td {
                    height: 26px;
                }
            }
            .elx-cell {
                padding: 0;
                height: 32px;
            }
            .el-button--small {
                padding: 5px 15px;
                margin: 3px 9px 0 0;
            }
        }
        .elx-table--footer-wrapper {
            margin-top: 0 !important;

            .elx-footer--row {
                .elx-footer--column {
                    height: 34px;
                }

                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
        }
        .elx-table--body-wrapper {
            padding-bottom: 180px !important;
        }
    }
    .bottom-div {
        margin-top: 14px;
        text-align: right;
    }
    .special-border {
        height: 100%;
        border-radius: 3px;
        border: 1px solid #ffcc00;
    }
    .sales-apcode {
        .el-tag {
            height: 24px;
            line-height: 22px;
            margin-left: 8px;
        }
        .info-icon {
            vertical-align: top;
            margin-top: 2px;
            margin-right: 5px;
        }
    }
}
</style>
